"use strict";

var _classCallCheck = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./util/error");

var messages = {
  0: "Network Error",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "Request-URI Too Long",
  415: "Unsupported Media Type",
  416: "Requested Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  444: "Connection Closed Without Response",
  451: "Unavailable For Legal Reasons",
  499: "Client Closed Request",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  510: "Not Extended",
  511: "Network Authentication Required",
  599: "Network Connect Timeout Error"
};
var nativeErrorKeys = ["fileName", "lineNumber", "columnNumber", "stack", "description", "number"];

function isC8Error(err) {
  return Boolean(err && err.isC8Error);
}

exports.isC8Error = isC8Error;

var C8Error =
/*#__PURE__*/
function (_error_1$default) {
  _inherits(C8Error, _error_1$default);

  function C8Error(response) {
    var _this;

    _classCallCheck(this, C8Error);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(C8Error).call(this));
    _this.name = "C8Error";
    _this.isC8Error = true;
    _this.response = response;
    _this.statusCode = response.statusCode;
    _this.message = response.body.errorMessage;
    _this.errorNum = response.body.errorNum;
    _this.code = response.body.code;
    var err = new Error(_this.message);
    err.name = _this.name;

    for (var _i = 0, _nativeErrorKeys = nativeErrorKeys; _i < _nativeErrorKeys.length; _i++) {
      var key = _nativeErrorKeys[_i];
      if (err[key]) _this[key] = err[key];
    }

    return _this;
  }

  return C8Error;
}(error_1.default);

exports.C8Error = C8Error;

var HttpError =
/*#__PURE__*/
function (_error_1$default2) {
  _inherits(HttpError, _error_1$default2);

  function HttpError(response) {
    var _this2;

    _classCallCheck(this, HttpError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HttpError).call(this));
    _this2.name = "HttpError";
    _this2.response = response;
    _this2.statusCode = response.statusCode || 500;
    _this2.message = messages[_this2.statusCode] || messages[500];
    _this2.code = _this2.statusCode;
    var err = new Error(_this2.message);
    err.name = _this2.name;

    for (var _i2 = 0, _nativeErrorKeys2 = nativeErrorKeys; _i2 < _nativeErrorKeys2.length; _i2++) {
      var key = _nativeErrorKeys2[_i2];
      if (err[key]) _this2[key] = err[key];
    }

    return _this2;
  }

  return HttpError;
}(error_1.default);

exports.HttpError = HttpError;